var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notifications > 0)?_c('span',{staticClass:"notification-counter"},[_vm._v(_vm._s(_vm.notifications > 99 ? '99+' : _vm.notifications))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }